import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const GithubIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="currentColor"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10.706 0C8.3315 9.84653e-05 6.03451 0.845114 4.22602 2.38385C2.41754 3.92258 1.21558 6.05462 0.835214 8.39848C0.454849 10.7423 0.920898 13.1451 2.14997 15.1768C3.37904 17.2084 5.29094 18.7365 7.54355 19.4875C8.04355 19.575 8.23105 19.275 8.23105 19.0125C8.23105 18.775 8.21854 17.9875 8.21854 17.15C5.70605 17.6125 5.05605 16.5375 4.85605 15.975C4.63413 15.428 4.28233 14.9431 3.83106 14.5625C3.48106 14.375 2.98107 13.9125 3.81855 13.9C4.13833 13.9347 4.44504 14.046 4.71268 14.2244C4.98033 14.4028 5.20101 14.6432 5.35605 14.925C5.49282 15.1707 5.67673 15.387 5.89723 15.5615C6.11774 15.736 6.37052 15.8653 6.64107 15.9419C6.91163 16.0185 7.19465 16.041 7.47391 16.0081C7.75318 15.9752 8.0232 15.8875 8.26851 15.75C8.3118 15.2416 8.53837 14.7663 8.90602 14.4125C6.68104 14.1625 4.35606 13.3 4.35606 9.47503C4.342 8.48118 4.70874 7.51961 5.38105 6.78753C5.07533 5.92375 5.1111 4.97581 5.48105 4.13753C5.48105 4.13753 6.31851 3.87502 8.23103 5.16253C9.8673 4.7125 11.5947 4.7125 13.231 5.16253C15.1435 3.86253 15.981 4.13753 15.981 4.13753C16.351 4.9758 16.3867 5.92376 16.081 6.78753C16.7553 7.51835 17.1224 8.48076 17.106 9.47503C17.106 13.3125 14.7685 14.1625 12.5435 14.4125C12.7821 14.6544 12.9659 14.9448 13.0824 15.264C13.1989 15.5833 13.2453 15.9238 13.2185 16.2625C13.2185 17.6 13.206 18.675 13.206 19.0125C13.206 19.275 13.3935 19.5875 13.8935 19.4875C16.1421 18.7304 18.0485 17.1988 19.2724 15.166C20.4962 13.1333 20.9578 10.7318 20.5748 8.39024C20.1918 6.04865 18.9891 3.91937 17.1814 2.38251C15.3737 0.84565 13.0787 0.00123491 10.706 0Z" />
  </svg>
)
const ForwardRef = forwardRef(GithubIcon)
export { ForwardRef as ReactComponent }
